(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nooryx-product-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(d) {
      try { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
      catch (e) { return d.toDateString(); }
    }
    function addDays(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }

    function init(root) {
      if (root.dataset.nxReady) return;
      root.dataset.nxReady = '1';

      // Gallery
      var slides = root.querySelectorAll('.nx-slide');
      var thumbs = root.querySelectorAll('.nx-thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var i = thumb.getAttribute('data-thumb');
          slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === i); });
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });

      // Quantity
      var qty = root.querySelector('[data-qty-input]');
      var minus = root.querySelector('[data-qty-minus]');
      var plus = root.querySelector('[data-qty-plus]');
      if (qty && minus && plus) {
        minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
        plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
      }

      // Variant price updates
      var select = root.querySelector('[data-variant-select]');
      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var price = root.querySelector('[data-price]');
          var compare = root.querySelector('[data-compare]');
          var save = root.querySelector('[data-save]');
          var stickyPrice = root.querySelector('[data-sticky-price]');
          if (price) price.textContent = opt.getAttribute('data-price');
          if (stickyPrice) stickyPrice.textContent = opt.getAttribute('data-price');
          var cmp = opt.getAttribute('data-compare');
          if (compare) { compare.textContent = cmp || ''; compare.hidden = !cmp; }
          if (save) save.hidden = true;
        });
      }

      // Delivery estimate dates
      var ship = root.querySelector('[data-ship]');
      if (ship) {
        var shipDays = parseInt(ship.getAttribute('data-ship-days'), 10) || 2;
        var dMin = parseInt(ship.getAttribute('data-deliver-min'), 10) || 4;
        var dMax = parseInt(ship.getAttribute('data-deliver-max'), 10) || 5;
        var o = ship.querySelector('[data-ship-order]');
        var s = ship.querySelector('[data-ship-ship]');
        var d = ship.querySelector('[data-ship-deliver]');
        if (o) o.textContent = 'Today, ' + fmt(addDays(0));
        if (s) s.textContent = 'By ' + fmt(addDays(shipDays));
        if (d) d.textContent = dMin === dMax ? fmt(addDays(dMin)) : fmt(addDays(dMin)) + ' to ' + fmt(addDays(dMax));
      }

      // Copy discount code
      root.querySelectorAll('[data-copy]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var code = btn.getAttribute('data-copy');
          var label = btn.querySelector('[data-copy-label]');
          var original = label ? label.textContent : '';
          function done() {
            if (!label) return;
            label.textContent = 'Copied!';
            setTimeout(function () { label.textContent = original; }, 1800);
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done, done);
          } else {
            var ta = document.createElement('textarea');
            ta.value = code; ta.setAttribute('readonly', '');
            ta.style.position = 'fixed'; ta.style.opacity = '0';
            document.body.appendChild(ta); ta.select();
            try { document.execCommand('copy'); } catch (e) {}
            document.body.removeChild(ta); done();
          }
        });
      });

      // Upsell popup after Add to cart
      var modal = root.querySelector('[data-upsell-modal]');
      var productForm = root.querySelector('form.nx-form');
      if (modal && productForm && window.fetch && window.FormData) {
        var addUrl = modal.getAttribute('data-cart-add');
        var changeUrl = modal.getAttribute('data-cart-change');
        var cartJsonUrl = modal.getAttribute('data-cart-json');
        var cartUrl = modal.getAttribute('data-cart-url');
        var accept = modal.querySelector('[data-upsell-accept]');
        var upVariant = accept.getAttribute('data-upsell-variant');
        var errEl = modal.querySelector('[data-upsell-error]');
        var lastAdded = null;
        var lastFocus = null;

        var openModal = function () {
          lastFocus = document.activeElement;
          errEl.hidden = true;
          accept.disabled = false;
          modal.hidden = false;
          document.documentElement.classList.add('nx-lock');
          accept.focus();
        };
        var closeModal = function () {
          modal.hidden = true;
          document.documentElement.classList.remove('nx-lock');
          if (lastFocus && lastFocus.focus) lastFocus.focus();
        };
        var showError = function (msg) { errEl.textContent = msg; errEl.hidden = false; };
        var setAddButtons = function (disabled) {
          root.querySelectorAll('button[name="add"]').forEach(function (b) { b.disabled = disabled; });
        };

        productForm.addEventListener('submit', function (ev) {
          if (ev.submitter && ev.submitter.name && ev.submitter.name !== 'add') return;
          ev.preventDefault();
          var data = new FormData(productForm);
          var variantId = String(data.get('id'));
          var qty = parseInt(data.get('quantity'), 10) || 1;
          setAddButtons(true);
          fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error('add-failed');
              lastAdded = { id: variantId, qty: qty };
              setAddButtons(false);
              openModal();
            })
            .catch(function () {
              setAddButtons(false);
              HTMLFormElement.prototype.submit.call(productForm);
            });
        });

        accept.addEventListener('click', function () {
          if (!lastAdded) return;
          accept.disabled = true;
          errEl.hidden = true;
          var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
          fetch(addUrl, { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(upVariant), quantity: lastAdded.qty }] }) })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error((res.d && res.d.description) || 'Sorry, the complete kit is not available right now.');
              return fetch(cartJsonUrl, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
            })
            .then(function (cart) {
              var line = (cart.items || []).filter(function (i) { return String(i.variant_id) === lastAdded.id; })[0];
              var remaining = line ? Math.max(0, line.quantity - lastAdded.qty) : 0;
              return fetch(changeUrl, { method: 'POST', headers: json, body: JSON.stringify({ id: lastAdded.id, quantity: remaining }) });
            })
            .then(function (r) {
              if (!r.ok) throw new Error('Could not update your cart.');
              window.location.href = cartUrl;
            })
            .catch(function (e) {
              showError(e.message || 'Something went wrong. Please try again.');
              accept.disabled = false;
            });
        });

        modal.querySelector('[data-upsell-skip]').addEventListener('click', function () { window.location.href = cartUrl; });
        modal.querySelectorAll('[data-upsell-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
        document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !modal.hidden) closeModal(); });
      }

      // Sticky mobile bar
      var sticky = root.querySelector('[data-sticky]');
      var addBtn = root.querySelector('[data-add-btn]');
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { sticky.hidden = e.isIntersecting; });
        }).observe(addBtn);
      }

      // Gift banner button scrolls to buy box
      var scrollBtn = root.querySelector('[data-scroll-buy]');
      if (scrollBtn) {
        scrollBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          var target = root.querySelector('.nx-buybox');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    function initAll() { document.querySelectorAll('.nx-pdp').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
